module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Bold-84c242fe1f30a86d5ab33ebce2be8b0b.woff2";